import { useEffect } from "react";

const KEYCLOAK_URL =
  "https://auth.7cut.video/realms/timeliner/protocol/openid-connect/auth";
const CLIENT_ID = "timeliner-client-4y7nkwz13vb0uqs";
const url = window.location.origin;
const REDIRECT_URI = `${url}/auth/callback`;

export default function LoggedOut() {
  useEffect(() => {
    window.location.href = "https://go.7cut.video";
  }, []);

  return <div>Redirecting to login...</div>;
}
